import {axios} from '@/store/config';

export default {
  // state
  state : {
    commercialPremises : []
  },
  // getters
  getters : {
    commercialPremises: state => state.commercialPremises,
  },

  // actions
  actions : {

    /**
     * Hämta kommersiella lokaler
     */
    getCommercialPremises({ commit }, {query = ""}){
      return new Promise((resolve, reject) => {
        axios.get(`/workorders/commercial/search?q=${query}`).then((response) => {
          commit('setCommercialPremises', response.data);

          resolve(response.data);
        }).catch(reject)
      })
    },

    getCommercialPremiseById({ commit}, id){
      return new Promise((resolve, reject) => {
        axios.get(`/workorders/commercial/${id}`).then((response) => {
          resolve(response.data);
        }).catch(reject)
      })
    },

    /**
     * Skapar felanmälan på kommersiella lokaler
     */
    createCommercialErrorReport({ commit, dispatch }, errorReport){
      return new Promise((resolve, reject) => {
        axios.post('workorders/commercial', errorReport ).then((response) => {
          resolve(response.data.helpdeskid);
        }).catch(reject)
      })
    }
  },

  // mutations
  mutations : {
    setCommercialPremises(state, commercialPremises){
      state.commercialPremises = commercialPremises;
    }
  }
}
